import React from 'react';
import axiosInstance from '../axiosConfig';
import { useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
import './Page.css';

function LogoutPage() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
        
      await axiosInstance.post('/auth/logout');
      const cookies = new Cookies();
      cookies.remove('connect.sid');
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      // Handle error
    }
  };

  return (
    <button type="button" onClick={handleLogout}>
      Logout
    </button>
  );
}

export default LogoutPage;
